import React from 'react'

function IshaEreceiptPreview(props) {
  return (
    <div> <img src={`data:image/png;base64,${props.location.state.detail}`}/></div>
  )
}

export default IshaEreceiptPreview